import '@/scss/taxonomy/product-category/product-category.scss';
import {loadMore} from "@/js/taxonomy/product-category/components/loadMore";
import {mobileProductFilterBtn} from "@/js/taxonomy/product-category/components/mobileProductFilterBtn";
import {newProductsSwiper} from "@/js/pages/home/components/newProductsSwiper";

loadMore();
mobileProductFilterBtn();
newProductsSwiper();